import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GeodestinosService } from '@cms-app/geodestinos';
var AdminActivitiesComponent = /** @class */ (function () {
    function AdminActivitiesComponent(router, geodestinosService) {
        this.router = router;
        this.geodestinosService = geodestinosService;
        this.rows = [];
        this.count = 0;
        this.page = 1;
        this.per_page = 20;
        this.query = '';
        this.loading = false;
    }
    AdminActivitiesComponent.prototype.ngOnInit = function () {
        this.find();
    };
    AdminActivitiesComponent.prototype.checkLink = function (row) {
        window.open(row.url, '_blank');
    };
    AdminActivitiesComponent.prototype.update = function (row) {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'visitar', row._id], {
            state: {
                data: row,
                type: 'visitar'
            }
        });
    };
    AdminActivitiesComponent.prototype.onPage = function (_a) {
        var offset = _a.offset;
        this.page = offset + 1;
        this.find();
    };
    AdminActivitiesComponent.prototype.onQuery = function (query) {
        this.query = query;
        this.find();
        console.log(query);
    };
    AdminActivitiesComponent.prototype.find = function () {
        var _this = this;
        this.loading = true;
        this.geodestinosService
            .fetch('visitar', this.query && this.query.length > 0 ? { q: this.query } : {}, { page: this.page || 1, per_page: this.per_page })
            .subscribe(function (_a) {
            var list = _a.list, count = _a.count;
            _this.rows = list;
            _this.count = count;
            _this.loading = false;
        }, function () {
            _this.loading = false;
        });
    };
    AdminActivitiesComponent.prototype.onAdd = function () {
        this.router.navigate(['admin', 'geodestinos', 'geodestino-detail', 'visitar', 'new']);
    };
    return AdminActivitiesComponent;
}());
export { AdminActivitiesComponent };
